<!--列表查看视图-->
<template>
  <div>
    <template v-if="lob==='SI'">
      <si-tab-container v-if="!masterFlag" ref="siTabContainer" :context="context" :action="action" :view-source="viewSource" />
      <si-tab-lcl-container v-if="masterFlag" ref="siTabLclContainer" :context="context" :action="action" :view-source="viewSource" />
    </template>
    <template v-if="lob==='SE'">
      <tab-container v-if="!masterFlag" ref="tabContainer" :context="context" :action="action" :view-source="viewSource" />
      <tab-lcl-container v-if="masterFlag" ref="tabLclContainer" :context="context" :action="action" :view-source="viewSource" />
    </template>
    <template v-if="lob==='RE'||lob==='RI'">
      <re-tab-container v-if="!masterFlag" ref="reTabContainer" :context="context" :action="action" :view-source="viewSource" />
      <re-tab-lcl-container v-if="masterFlag" ref="reTabLclContainer" :context="context" :action="action" :view-source="viewSource" />
    </template>
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import reTabContainer from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabContainer'
import reTabLclContainer from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabLclContainer'
import siTabContainer from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabContainer'
import siTabLclContainer from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabLclContainer'
import tabContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabContainer'
import tabLclContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabLclContainer'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'SalesQueryContainerTab',
  components: {
    siTabContainer, siTabLclContainer,
    reTabContainer, reTabLclContainer,
    tabContainer, tabLclContainer
  },
  props: {
    job: { type: Object, required: true },
    lob: { type: String, required: true, validator: (value) => { return ['AE', 'SE', 'SI', 'RE', 'RI', 'AI', ''].includes(value) } }, // AE SE SI RWE, ''(空字符串）为解决初始化警告问题
    masterFlag: { type: Boolean, required: true },
    context: { type: Object, required: false },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    }
  },
  data() {
    return {
      loading: false,
      selectTypeNames: TYPE_NAMES,
      activeTabName: 'tabContainer',
      action: 'look'
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.loading = getLoading()
      switch (this.lob) {
        case 'SE': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabLclContainer' : 'tabContainer'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'SI': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'siTabLclContainer' : 'siTabContainer'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'RE':
        case 'RI': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'reTabLclContainer' : 'reTabContainer'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
      }
      this.loading.close()
    }
  }
}
</script>

<style lang="scss">
</style>
